var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control dsf_teas_assess_iframe mobile" },
    [
      _vm.sourcesUrl
        ? _c("iframe", {
            attrs: {
              src: _vm.sourcesUrl,
              frameborder: "0",
              width: "100%",
              height: "100%",
            },
          })
        : _c("div", { staticClass: "no-src" }, [_vm._v("请配置评估列表地址")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }